import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import TrainingDetailsSection from "../components/TrainingDetails";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

export default function TrainingDetails(props: {
  disableCustomTheme?: boolean;
}) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        <TrainingDetailsSection />
        <Footer />
      </div>
    </AppTheme>
  );
}
